import React from 'react';
import cx from 'classnames';
import { upperFirst } from 'lodash';
import { cut, firstNameAndLastInitial } from '../utils';

/* eslint-disable react/prop-types */
const AppointmentInfo = (props) => {
  const appointments = props.appointments || [props];
  const wrapperClassName = cx('c-appointment-info', {
    'c-appointment-info--cancel': props.cancel,
    'c-appointment-info--waiting-list': props.waitingList,
  });

  const shouldShowInfo = (appointments.length && appointments[0].confirmationCode) || props.waitingList;
  if (!shouldShowInfo) {
    return (
      <div className={wrapperClassName}>
        <div className="c-appointment-info__shield" />
      </div>
    );
  }

  return (
    <div className={wrapperClassName}>
      <div className="c-appointment-info__shield" />
      <h3 className="u-text-large u-fw-bold u-mb-6">
        Appointment details
      </h3>
      {
        appointments.map((appt, idx) => (
          <div key={(appt.confirmationCode || idx)}>
            {
              (appointments.length > 1 && idx > 0) && (
                <div className="c-divider u-mt-5 u-mb-5" />
              )
            }
            {
              appt.shopLocation && (
                <div className="u-flex u-justify-content-space-between u-align-center u-mb-3">
                  <span className="u-text-normal u-co-grey u-hide-on-mobile">
                    Location
                  </span>
                  <span className="u-text-medium u-co-grey u-hide-on-desktop">
                    Location
                  </span>
                  <span className="u-text-normal u-hide-on-mobile">
                    {cut(appt.shopLocation, 20)}
                  </span>
                  <span className="u-text-medium u-hide-on-desktop">
                    {cut(appt.shopLocation, 20)}
                  </span>
                </div>
              )
            }
            {
              appt.confirmationCode && (
                <div className="u-flex u-justify-content-space-between u-align-center u-mb-3">
                  <span className="u-text-normal u-co-grey u-hide-on-mobile">
                    Confirmation code
                  </span>
                  <span className="u-text-medium u-co-grey u-hide-on-desktop">
                    Confirm. code
                  </span>
                  <span className="u-text-normal u-hide-on-mobile">
                    {appt.confirmationCode}
                  </span>
                  <span className="u-text-medium u-hide-on-desktop">
                    {appt.confirmationCode}
                  </span>
                </div>
              )
            }
            {
              appt.position && (
                <div className="u-flex u-justify-content-space-between u-align-center u-mb-3">
                  <span className="u-text-normal u-co-grey u-hide-on-mobile">
                    Waiting list position
                  </span>
                  <span className="u-text-medium u-co-grey u-hide-on-desktop">
                    Waiting list position
                  </span>
                  <span className="u-text-normal u-hide-on-mobile">
                    {appt.position}
                  </span>
                  <span className="u-text-medium u-hide-on-desktop">
                    {appt.position}
                  </span>
                </div>
              )
            }
            {
              appt.barberName && (
                <div className="u-flex u-justify-content-space-between u-align-center u-mb-3">
                  <span className="u-text-normal u-co-grey u-hide-on-mobile">
                    Professional
                  </span>
                  <span className="u-text-medium u-co-grey u-hide-on-desktop">
                    Professional
                  </span>
                  <span className="u-text-normal u-hide-on-mobile">
                    {appt.barberName}
                  </span>
                  <span className="u-text-medium u-hide-on-desktop">
                    {appt.barberName}
                  </span>
                </div>
              )
            }
            {
              appt.customerName && (
                <div className="u-flex u-justify-content-space-between u-align-center u-mb-3">
                  <span className="u-text-normal u-co-grey u-hide-on-mobile">
                    Client
                  </span>
                  <span className="u-text-medium u-co-grey u-hide-on-desktop">
                    Client
                  </span>
                  <span className="u-text-normal u-hide-on-mobile">
                    {firstNameAndLastInitial(appt.customerName)}
                  </span>
                  <span className="u-text-medium u-hide-on-desktop">
                    {firstNameAndLastInitial(appt.customerName)}
                  </span>
                </div>
              )
            }
            <div className="u-flex u-justify-content-space-between u-align-center u-mb-3">
              <span className="u-text-normal u-co-grey u-hide-on-mobile">
                Service
              </span>
              <span className="u-text-medium u-co-grey u-hide-on-desktop">
                Service
              </span>
              <span className="u-text-normal u-hide-on-mobile">
                {upperFirst(cut(appt.service, 20))}
              </span>
              <span className="u-text-medium u-hide-on-desktop">
                {upperFirst(cut(appt.service, 20))}
              </span>
            </div>
            {
              appt.date && (
                <div className="u-flex u-justify-content-space-between u-align-center u-mb-3">
                  <span className="u-text-normal u-co-grey u-hide-on-mobile">
                    Time
                  </span>
                  <span className="u-text-medium u-co-grey u-hide-on-desktop">
                    Time
                  </span>
                  <span className="u-text-normal u-hide-on-mobile">
                    {appt.date}
                  </span>
                  <span className="u-text-medium u-hide-on-desktop">
                    {appt.date}
                  </span>
                </div>
              )
            }
            <div className="u-flex u-justify-content-space-between u-align-center">
              <span className="u-text-normal u-co-grey u-hide-on-mobile">
                Duration
              </span>
              <span className="u-text-medium u-co-grey u-hide-on-desktop">
                Duration
              </span>
              <span className="u-text-normal u-hide-on-mobile">
                {appt.duration}
              </span>
              <span className="u-text-medium u-hide-on-desktop">
                {appt.duration}
              </span>
            </div>
            {
              appt.appointmentNote && (
                <div className="u-flex u-justify-content-space-between u-mt-3">
                  <span className="u-text-normal u-co-grey u-hide-on-mobile">
                    Note
                  </span>
                  <span className="u-text-medium u-co-grey u-hide-on-desktop">
                    Note
                  </span>
                  <span className="u-text-normal u-hide-on-mobile u-ta-right u-1/2">
                    {cut(appt.appointmentNote, 60)}
                  </span>
                  <span className="u-text-medium u-hide-on-desktop u-ta-right u-1/2">
                    {cut(appt.appointmentNote, 60)}
                  </span>
                </div>
              )
            }
          </div>
        ))
      }
      {props.children}
    </div>
  );
};

export default AppointmentInfo;



// WEBPACK FOOTER //
// ./src/app/notifications/shared/AppointmentInfo.jsx